import en from './translations/strings.neutral.json';

export const resources = {
    en: en,
};

export const supportedLocales = ['en'];
